import appConstants from "../../../../constants";

export function hasSuggestion(selectedSuggestions, suggestion) {
  return selectedSuggestions.filter(selectedSuggestion => selectedSuggestion[appConstants.KEY_CODE] === suggestion[appConstants.KEY_CODE]).length > 0;
}

export function removeSuggestion(selectedSuggestions, suggestion) {
  return selectedSuggestions.filter(selectedSuggestion => selectedSuggestion[appConstants.KEY_CODE] !== suggestion[appConstants.KEY_CODE]);
}
